import * as types from '../action-types'
import { JobEntity } from './types'
import { ShiftEntity } from 'syft-acp-core/store/shifts/types'

export const updateJob = (
  id: number,
  data: JobEntity,
  onSuccessCallback?: () => void,
  listingId?: number,
  shift?: ShiftEntity,
) => ({
  type: types.JOB_UPDATE_BEGIN,
  id,
  data,
  onSuccessCallback,
  listingId,
  shift,
})
export type UpdateJobAction = ReturnType<typeof updateJob>

export const fetchAdminJob = (id: number) => ({
  type: types.FETCH_ADMIN_JOB_BEGIN,
  payload: {
    id,
  },
})
export type FetchAdminJob = ReturnType<typeof fetchAdminJob>

export const updateStopJobOffersByShift = (id: number, payload: string[]) => ({
  type: types.JOB_STOP_OFFERS_UPDATE_BY_SHIFT,
  id,
  payload,
})
export type UpdateStopJobOfersByShiftAction = ReturnType<typeof updateStopJobOffersByShift>

export const rateWorker = (jobID: number, workerID: number, rate: number) => ({
  type: types.JOB_RATE_WORKER_BEGIN,
  jobID,
  workerID,
  rate,
})
export type RateWorkerAction = ReturnType<typeof rateWorker>

export const deleteRating = (jobID: number, workerID: number) => ({
  type: types.RATING_DELETE_BEGIN,
  jobID,
  workerID,
})
export type DeleteRatingAction = ReturnType<typeof deleteRating>

export const extendLTA = (jobID: number, dates: string[]) => ({
  type: types.JOB_EXTEND_LTA_BEGIN,
  jobID,
  dates,
})
export type ExtendLTAAction = ReturnType<typeof extendLTA>

export const fetchLTAExtensions = (jobID: number) => ({
  type: types.JOB_FETCH_LTA_EXTENSIONS_BEGIN,
  jobID,
})
export type FetchLTAExtensionsAction = ReturnType<typeof fetchLTAExtensions>

export const cancelLTAExtension = (jobID: number) => ({
  type: types.JOB_CANCEL_LTA_EXTENSION_BEGIN,
  jobID,
})
export type CancelLTAExtensionAction = ReturnType<typeof cancelLTAExtension>

export const extendBooking = (jobID: number, workerID: number) => ({
  type: types.JOB_EXTEND_BOOKING_BEGIN,
  jobID,
  workerID,
})
export type ExtendBookingAction = ReturnType<typeof extendBooking>

export const extendAgencyBooking = (jobID: number, agencyWorkerID: number) => ({
  type: types.JOB_EXTEND_AGENCY_BOOKING_BEGIN,
  jobID,
  agencyWorkerID,
})
export type ExtendAgencyBookingAction = ReturnType<typeof extendAgencyBooking>

export type JobAction = UpdateJobAction | RateWorkerAction | DeleteRatingAction | ExtendLTAAction | FetchLTAExtensionsAction | CancelLTAExtensionAction | ExtendBookingAction | ExtendAgencyBookingAction
